import HeartIcon from '@propertypal/shared/src/resources/icons/map/heart-solid-full.svg?url';
import HouseIcon from '@propertypal/shared/src/resources/icons/map/house-solid-full.svg?url';
import { MarkerType } from '@propertypal/shared/src/types/map';
import { formatShortNumber } from '@propertypal/shared/src/utils/text';

export const createMapMarker = (active: boolean, marker: MarkerType, clicked: number[]) => {
  const content = document.createElement('div');
  content.className = `google-map-marker ${active ? 'google-map-marker-active' : ''}`;

  if (marker.units === undefined) {
    const markerIcon = marker?.icon?.[active ? 'selected' : 'default']?.src;
    const img = document.createElement('img');
    img.src = markerIcon || HouseIcon.src;
    if (!markerIcon) img.style.maxWidth = '60%';
    else content.className = active ? 'google-map-marker-active' : '';
    content.append(img);
    // @ts-ignore
  } else if (marker.properties && marker.properties.length === 1) {
    const label = document.createElement('p');

    if (marker.properties[0].shortlisted) {
      const favIcon = document.createElement('img');
      favIcon.src = HeartIcon.src;
      favIcon.className = 'google-map-marker-favourite';
      content.append(favIcon);
    }

    if (marker.properties[0].price?.price) {
      const priceText = formatShortNumber(marker.properties[0].price.price);
      label.textContent = `${marker.properties[0].price.currencySymbol}${priceText}`;
    } else {
      const img = document.createElement('img');
      img.src = HouseIcon.src;
      content.append(img);
    }

    if (clicked.includes(marker.properties[0].id)) {
      content.className += ' google-map-marker-clicked';
    }

    content.append(label);
  } else {
    const label = document.createElement('p');
    label.textContent = !marker.units ? '' : marker.units && marker.units < 100 ? marker.units.toString() : '+';
    label.className = marker.units && marker.units < 100 ? '' : 'pp-marker-plus';
    const img = document.createElement('img');
    img.src = HouseIcon.src;
    content.className += ' google-map-marker-compact';
    content.append(img);
    content.append(label);
  }

  if (marker.importantPlace) {
    const place = document.createElement('div');
    place.textContent = marker.importantPlace.content;
    const classes = ['important-place-pill'];
    if (marker.importantPlace.isSearched) classes.push('important-place-pill-searched');
    place.className = classes.join(' ');
    content.append(place);
  }

  return content;
};

export default createMapMarker;
